import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import PropTypes from 'prop-types';
import { createElement } from 'react';
import YearsLabels from '../YearsLabels';
import MonthsLabels from '../MonthsLabels';
import DaysLabels from '../DaysLabels';
import './style.scss';
import { jsx as _jsx } from "react/jsx-runtime";

var Levels = function Levels(props) {
  var activeLevel = props.activeLevel;

  switch (activeLevel) {
    case 'year':
      return /*#__PURE__*/createElement(YearsLabels, _objectSpread(_objectSpread({}, props), {}, {
        key: 'year'
      }));

    case 'month':
      return [/*#__PURE__*/createElement(MonthsLabels, _objectSpread(_objectSpread({}, props), {}, {
        key: 'month'
      })), /*#__PURE__*/createElement(YearsLabels, _objectSpread(_objectSpread({}, props), {}, {
        key: 'year'
      }))];

    case 'day':
      return [/*#__PURE__*/createElement(DaysLabels, _objectSpread(_objectSpread({}, props), {}, {
        key: 'day'
      })), /*#__PURE__*/createElement(MonthsLabels, _objectSpread(_objectSpread({}, props), {}, {
        key: 'month'
      }))];
  }

  return null;
};

Levels.propTypes = {
  activeLevel: PropTypes.string
};

var XAxis = function XAxis(_ref) {
  var period = _ref.period,
      getX = _ref.getX,
      dayWidth = _ref.dayWidth,
      vertical = _ref.vertical,
      activeLevel = _ref.activeLevel;
  return /*#__PURE__*/_jsx(Levels, {
    period: period,
    getX: getX,
    dayWidth: dayWidth,
    height: 20,
    vertical: vertical,
    activeLevel: activeLevel
  });
};

XAxis.propTypes = {
  getX: PropTypes.func,
  period: PropTypes.object,
  activeLevel: PropTypes.string,
  dayWidth: PropTypes.number,
  vertical: PropTypes.bool
};
export default XAxis;